import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OioInput = _resolveComponent("OioInput")!

  return (_openBlock(), _createBlock(_component_OioInput, {
    value: _ctx.value,
    onPressEnter: _ctx.onEnter,
    placeholder: _ctx.placeholder,
    "onUpdate:value": _ctx.change
  }, null, 8, ["value", "onPressEnter", "placeholder", "onUpdate:value"]))
}